import React, { useMemo } from "react"
import Image from "next/image"

const StarRatingView: React.FunctionComponent<{
    ratingsAverage: number
}> = ({
    ratingsAverage
}) => {
    const starsRenderingMode = useMemo(() => {
        const renderingMode: string[] = []
        for (let i = 10; i <= 50; i += 10) {
            if ((ratingsAverage * 10) >= i) {
                renderingMode.push("full")
            } else if ((ratingsAverage * 10) >= i - 5) {
                renderingMode.push("half")
            } else {
                renderingMode.push("empty")
            }
        }

        return renderingMode
    }, [ratingsAverage])

    return (
        <div className="flex gap-x-[2px] items-center">
            {starsRenderingMode.map((each, index) => {
                return <Image key={index}
                    width="16" height="16"
                    src={`/images/ic_star_rating_${each}_small.svg`}
                    alt={`Ratings: ${ratingsAverage} / 5`} />
            })}
        </div>
    )
}

export default StarRatingView
